import React, { useState, useEffect, useRef } from "react";
import { V2Button } from "@abyss/web/ui/Button";
import { Drawer } from "@abyss/web/ui/Drawer";

import styles from "./floatingchat.module.css";

import { PlanDetail } from "../PlanDetail";

export const FloatingChat = () => {
  const [chatVisible, setChatVisible] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <React.Fragment>
      <PlanDetail />
      <div>
        {chatVisible && (
          <div className={styles.chatbox}>
            <div className={styles.chatboxInner}>
              <div className={styles.chatboxHead}>
                <div className={styles.chatboxTitle}>
                  Do you have questions about these plans?
                </div>
                <div
                  className={styles.chatboxClose}
                  onClick={() => {
                    setChatVisible(false);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="39"
                    height="39"
                    viewBox="0 0 39 39"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_6993_30597)">
                      <path
                        d="M27 13.5107L25.4893 12L19.5 17.9893L13.5107 12L12 13.5107L17.9893 19.5L12 25.4893L13.5107 27L19.5 21.0107L25.4893 27L27 25.4893L21.0107 19.5L27 13.5107Z"
                        fill="#196ECF"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_6993_30597">
                        <rect width="38.75" height="38.75" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className={styles.chatboxFt}>
                <V2Button
                  onClick={() => setIsOpen(true)}
                  aria-haspopup="dialog"
                >
                  <span className={styles.buttonWrap}>
                    <span className={styles.buttonText}>
                      Ask the plan companion
                    </span>
                    <span className={styles.buttonIcon}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M16.7075 13.6987C13.1142 13.6987 10.1995 10.7841 10.1995 7.19074C10.1995 7.08874 10.1171 7.00244 10.0112 7.00244C9.90527 7.00244 9.82289 7.08482 9.82289 7.19074C9.82289 10.7841 6.90821 13.6987 3.31488 13.6987C3.21289 13.6987 3.12659 13.7811 3.12659 13.887C3.12659 13.993 3.20897 14.0753 3.31488 14.0753C6.90821 14.0753 9.82289 16.99 9.82289 20.5834C9.82289 20.6853 9.90527 20.7716 10.0112 20.7716C10.1171 20.7716 10.1995 20.6893 10.1995 20.5834C10.1995 16.99 13.1142 14.0753 16.7075 14.0753C16.8095 14.0753 16.8958 13.993 16.8958 13.887C16.8958 13.7811 16.8134 13.6987 16.7075 13.6987Z"
                          fill="white"
                        />
                        <path
                          d="M20.0536 7.04152C18.2884 7.04152 16.8565 5.60968 16.8565 3.84439C16.8565 3.7934 16.8134 3.75024 16.7624 3.75024C16.7114 3.75024 16.6682 3.7934 16.6682 3.84439C16.6682 5.60968 15.2364 7.04152 13.4711 7.04152C13.4201 7.04152 13.377 7.08467 13.377 7.13566C13.377 7.18666 13.4201 7.22981 13.4711 7.22981C15.2364 7.22981 16.6682 8.66165 16.6682 10.4269C16.6682 10.4779 16.7114 10.5211 16.7624 10.5211C16.8134 10.5211 16.8565 10.4779 16.8565 10.4269C16.8565 8.66165 18.2884 7.22981 20.0536 7.22981C20.1046 7.22981 20.1478 7.18666 20.1478 7.13566C20.1478 7.08467 20.1046 7.04152 20.0536 7.04152Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </span>
                </V2Button>
              </div>
            </div>
          </div>
        )}
      </div>

      <Drawer
        title=""
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        size={"md"}
      >
        <img src="/assets/images/drawerimg.png" />
      </Drawer>
    </React.Fragment>
  );
};
